import type { ReactNode } from 'react';
import React from 'react';
import * as styles from './OneColumnPage.module.scss';

type OneColumnPageProps = {
  children: ReactNode;
};

const OneColumnPage = (props: OneColumnPageProps) => (
  <div className={styles.container}>
    <div className={styles.content}>{props.children}</div>
  </div>
);

export default OneColumnPage;
